import { render, staticRenderFns } from "./SurveyNoteViewPractitioner.vue?vue&type=template&id=67488980"
import script from "./SurveyNoteViewPractitioner.vue?vue&type=script&lang=js"
export * from "./SurveyNoteViewPractitioner.vue?vue&type=script&lang=js"
import style0 from "./SurveyNoteViewPractitioner.vue?vue&type=style&index=0&id=67488980&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports